var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "chat",
    width: 23.192,
    height: 18.594,
    viewBox: "0 0 23.192 18.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M16.864 50.758H1.306A1.307 1.307 0 0 0 0 52.064V61.4a1.307 1.307 0 0 0 1.306 1.3h1.009v3.475a.547.547 0 0 0 .934.387L7.11 62.7h.775a.547.547 0 0 0 0-1.094H6.846a.545.545 0 0 0-.35.158l-3.087 3.094v-2.75a.547.547 0 0 0-.545-.5H1.306a.212.212 0 0 1-.212-.212v-9.332a.212.212 0 0 1 .212-.212h15.558a.212.212 0 0 1 .212.212v3.581a.547.547 0 0 0 1.094 0v-3.581a1.307 1.307 0 0 0-1.306-1.306z",
    className: "cls-1",
    "data-name": "Path 41",
    transform: "translate(0 -50.758)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(9.69 6.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M226.119 198.492h-10.89a1.307 1.307 0 0 0-1.306 1.306v6.367a1.307 1.307 0 0 0 1.306 1.306h6.818l2.762 2.762a.547.547 0 0 0 .934-.387v-2.375h.376a1.307 1.307 0 0 0 1.306-1.306V199.8a1.307 1.307 0 0 0-1.306-1.308zm.212 7.673a.212.212 0 0 1-.212.212h-.919a.547.547 0 0 0-.545.5v1.644l-1.986-1.987-.006-.006-.022-.02a.544.544 0 0 0-.36-.136h-7.045a.212.212 0 0 1-.212-.212v-6.36a.212.212 0 0 1 .212-.212h10.89a.212.212 0 0 1 .212.212z",
    className: "cls-1",
    "data-name": "Path 42",
    transform: "translate(-213.923 -198.492)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(15.894 10.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M351.433 285.53a.547.547 0 1 0 .547.547.547.547 0 0 0-.547-.547z",
    className: "cls-1",
    "data-name": "Path 43",
    transform: "translate(-350.886 -285.53)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(3.559 3.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M89.076 130.611h-9.957a.547.547 0 1 0 0 1.094h9.957a.547.547 0 1 0 0-1.094z",
    className: "cls-1",
    "data-name": "Path 44",
    transform: "translate(-78.572 -130.611)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(3.559 7.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M82.9 210.465h-3.781a.547.547 0 0 0 0 1.094H82.9a.547.547 0 1 0 0-1.094z",
    className: "cls-1",
    "data-name": "Path 45",
    transform: "translate(-78.572 -210.465)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(13.352 10.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M295.306 285.53a.547.547 0 1 0 .547.547.547.547 0 0 0-.547-.547z",
    className: "cls-1",
    "data-name": "Path 46",
    transform: "translate(-294.759 -285.53)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(18.436 10.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M407.548 285.53a.547.547 0 1 0 .547.547.547.547 0 0 0-.547-.547z",
    className: "cls-1",
    "data-name": "Path 47",
    transform: "translate(-407.001 -285.53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.7eb31ce5.svg";
export { ForwardRef as ReactComponent };